import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link as RRLinkUnstyled } from 'react-router-dom';
import color from 'tinycolor2';

export const Nav = styled.nav`
  flex: 1 1 auto;
  min-width: 0;
  overflow: visible;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
`;

export const P = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin: 0;
  color: ${(props) => props.theme['color.text.body']};
  flex: 1 1 auto;
  min-width: 0;
  overflow: visible;

  /* chevron icon */
  i {
    flex-shrink: 0;
    color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.4).toString()};
    margin: 0 4px;
  }
`;

export const Label = styled.span`
  line-height: 24px;
  color: ${(props) => props.last
    ? props.theme['color.text.body'] : props.theme['color.text.light']};
  font-size: 14px;
`;

export const CrumbText = styled.span`
  white-space: nowrap;

  ${(props) =>
    props.$truncate
      ? `
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1 1 auto;
  `
      : `
    flex: 0 0 auto;
    overflow: visible;
  `}
`;

export const RRLink = styled(({ last, $truncate, ...rest }) => (
  <RRLinkUnstyled {...rest} />
))`
  line-height: 24px;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  ${(props) =>
    props.$truncate
      ? `
    flex: 0 1 auto;
    min-width: 0;
    max-width: min(40vw, 320px);
  `
      : `
    flex: 0 0 auto;
    min-width: 0;
    max-width: none;
  `}

  color: ${(props) => props.last ? props.theme['color.text.body'] : props.theme['color.text.light']};
  font-size: 14px;
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme['color.text.body']};
  }

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    ${(props) =>
    props.$truncate
      ? `
      max-width: min(55vw, 260px);
      flex: 0 1 auto;
      min-width: 0;
    `
      : `
      max-width: none;
      flex: 0 0 auto;
    `}
  }
`;

RRLink.propTypes = {
  last: PropTypes.bool,
  $truncate: PropTypes.bool,
};
